import React from 'react';

export default function CFPHero({ cfpData }) {
    if (!cfpData) return null;
    return (
        <section className="cfp-hero">
            <style>{`
                .cfp-hero {
                    position: relative;
                    padding: 160px 0 100px;
                    background: var(--eventflow-black);
                    overflow: hidden;
                    text-align: center;
                }
                /* bg glow */
                .cfp-hero::before {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background:
                        radial-gradient(ellipse at 50% 0%, rgba(var(--eventflow-primary-rgb),0.18) 0%, transparent 60%),
                        radial-gradient(ellipse at 80% 80%, rgba(var(--eventflow-base-rgb),0.1) 0%, transparent 50%);
                    pointer-events: none;
                }
                /* grid lines */
                .cfp-hero::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background-image:
                        linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
                    background-size: 60px 60px;
                    pointer-events: none;
                }
                .cfp-hero__inner {
                    position: relative;
                    z-index: 2;
                }
                .cfp-hero__tag {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: var(--eventflow-base);
                    margin-bottom: 24px;
                }
                .cfp-hero__tag::before,
                .cfp-hero__tag::after {
                    content: '';
                    display: inline-block;
                    width: 32px; height: 1px;
                    background: var(--eventflow-base);
                    opacity: 0.5;
                }
                .cfp-hero__title {
                    font-family: var(--eventflow-font);
                    font-size: 64px;
                    font-weight: 900;
                    color: var(--eventflow-white);
                    line-height: 1.05;
                    letter-spacing: -2px;
                    margin-bottom: 20px;
                }
                .cfp-hero__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .cfp-hero__sub {
                    font-family: var(--eventflow-font);
                    font-size: 18px;
                    color: rgba(255,255,255,0.55);
                    max-width: 600px;
                    margin: 0 auto 40px;
                    line-height: 1.7;
                }
                .cfp-hero__pills {
                    display: flex;
                    justify-content: center;
                    gap: 10px;
                    flex-wrap: wrap;
                    margin-bottom: 48px;
                }
                .cfp-hero__pill {
                    font-family: 'Courier New', monospace;
                    font-size: 12px;
                    font-weight: 700;
                    color: rgba(178,13,93,0.8);
                    background: rgba(178,13,93,0.08);
                    border: 1px solid rgba(178,13,93,0.18);
                    border-radius: 6px;
                    padding: 6px 14px;
                    letter-spacing: 0.5px;
                }
                .cfp-hero__deadline {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    background: rgba(255,255,255,0.04);
                    border: 1px solid rgba(255,255,255,0.08);
                    border-radius: 50px;
                    padding: 10px 24px;
                    font-family: var(--eventflow-font);
                    font-size: 14px;
                    color: rgba(255,255,255,0.55);
                }
                .cfp-hero__deadline strong {
                    color: var(--eventflow-white);
                    font-weight: 700;
                }
                .cfp-hero__deadline i {
                    color: var(--eventflow-base);
                    font-size: 13px;
                }
                @media (max-width: 768px) {
                    .cfp-hero__title { font-size: 40px; letter-spacing: -1px; }
                    .cfp-hero { padding: 130px 0 70px; }
                }
            `}</style>

            <div className="container">
                <div className="cfp-hero__inner wow fadeInUp" data-wow-delay="100ms">
                    <div className="cfp-hero__tag">{cfpData.hero.tagline}</div>
                    <h1 className="cfp-hero__title">
                        {cfpData.hero.titleLine1}<br />
                        <span>{cfpData.hero.titleLine2}</span>
                    </h1>
                    <p className="cfp-hero__sub">
                        {cfpData.hero.subtitle}
                    </p>
                    <div className="cfp-hero__pills">
                        {cfpData.hero.tracks.map((t,i) => (
                            <span className="cfp-hero__pill" key={i}>{t}</span>
                        ))}
                    </div>
                    <div className="cfp-hero__deadline">
                        <i className="fa fa-clock" />
                        Submission Deadline: <strong>{cfpData.hero.deadline}</strong>
                    </div>
                </div>
            </div>
        </section>
    );
}
